const BASE_PATH_FALLBACKS = ["/drone"];

function normalizeBasePath(value) {
  if (typeof value !== "string") return "";
  const raw = value.trim();
  if (!raw || raw === "/") return "";

  const fromUrl = (() => {
    try {
      if (/^https?:\/\//i.test(raw)) {
        return new URL(raw).pathname;
      }
    } catch {
      return "";
    }
    return raw;
  })();

  if (!fromUrl) return "";
  let next = fromUrl.startsWith("/") ? fromUrl : `/${fromUrl}`;
  next = next.replace(/\/+$/g, "");
  return next === "/" ? "" : next;
}

function inferBasePathFromLocation() {
  if (typeof window === "undefined") return "";
  const pathname = window.location.pathname || "";
  return (
    BASE_PATH_FALLBACKS.find(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    ) || ""
  );
}

export const APP_BASENAME =
  normalizeBasePath(process.env.REACT_APP_BASENAME) ||
  inferBasePathFromLocation();

export function withBasePath(pathname = "/") {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (!APP_BASENAME) return normalizedPath;
  if (normalizedPath === "/") return `${APP_BASENAME}/`;
  return `${APP_BASENAME}${normalizedPath}`;
}
